import { BreadType } from 'types/bread'
import { StockUnionType } from 'types/stock'
import { Action, Dispatch } from 'redux'
import { saveCollectiveStocksConfirmAction } from 'reducks/confirm/actions'
import { push } from 'connected-react-router'

const saveCollectiveStocksConfirm = (
  breads: BreadType[],
  dates: Date[],
  deletedMonth: Date | undefined,
  type: StockUnionType
) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(saveCollectiveStocksConfirmAction({ breads, dates, deletedMonth }))
    const path = (() => {
      switch (type) {
        case 'preorder':
          return `/schedule/collective_setting/confirm`
        case 'delivery':
          return `/schedule/delivery/collective_setting/confirm`
        default:
          return `/schedule/collective_setting/confirm`
      }
    })()
    dispatch(push(path))
  }
}

export default saveCollectiveStocksConfirm
